const ThemeKey = Object.freeze({
	Light: 'theme_light',
	Dark: 'theme_dark',
});

export default ThemeKey;
